module.exports = __webpack_public_path__ + "static/media/collage-camel-small.3c584c00.gif";